import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
})
export class TablePermissionsComponent implements OnInit {

    @Input('data') config;

    constructor() { }

    ngOnInit() { }
    // Método para obter a cor do badge com base no ID do papel
    getRoleColor(roleId: string): string {
        switch (roleId) {
            case '2': return 'primary';   // Técnico
            case '3': return 'secondary'; // Funcionário
            case '6': return 'tertiary';  // Comerciante
            case '7': return 'success';   // Consumidor
            default: return 'medium';
        }
    }
}
